// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"04252130","440":"25638672","489":"324ab2ba","673":"0390692f","871":"827d04c6","951":"c1d17efc"}[chunkId] + ".chunk.css";
};